import { Pipe, PipeTransform } from '@angular/core';

import {SubtitlesService} from "../core";

@Pipe({
    name: 'shortDayName'
})
export class ShortDayNamePipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    transform(value: number): string {
        const days = this.subtitles.setSubtitle(1658).split(' ');
        return days[value];
    }
}
